import styled from "styled-components"

import CardBase from "./Card"

export const Card = styled(CardBase)`
  margin-bottom: ${({theme}) => theme.spacing.two};
  height: 140px;
  text-transform: none;
`
